import type { IntlShape } from 'react-intl';

import type { ADFEntity } from '@atlaskit/adf-utils/types';
import type { ExtensionModule } from '@atlaskit/editor-common/extensions';

import {
	AGENT_MANAGED_EXTENSION_KEY,
	AGENT_MANAGED_EXTENSION_TYPE_DEFAULT,
	type AgentManagedExtensionParameters,
} from '../common/agentManagedExtensionPluginType';
import { messages } from '../common/messages';
import { generateAiManagedObjectId, generateLocalId } from '../common/utils';

import { getAgentManagedExtensionIconLoader } from './icon';

/**
 * `quickInsert` items contributed by the agent-managed extension manifest.
 * Returns the ADF entity for a new agent-managed bodied extension; the
 * configure popup is auto-opened by the plugin's `view.update` once the
 * inserted node appears in the doc. The product (e.g. Confluence) gates
 * the registration of this provider with the relevant experiment, so no
 * gating is needed at this layer.
 */
export const getQuickInsertModules = ({
	extensionType = AGENT_MANAGED_EXTENSION_TYPE_DEFAULT,
	intl,
}: {
	extensionType?: string;
	intl: IntlShape;
}): ExtensionModule[] => {
	return [
		{
			key: 'agent-managed-block',
			title: intl.formatMessage(messages.insertTitle),
			description: intl.formatMessage(messages.insertDescription),
			keywords: ['agent', 'rovo', 'block', 'manage', 'prompt'],
			priority: 700,
			icon: getAgentManagedExtensionIconLoader('', 'small'),
			action: (): Promise<ADFEntity> => {
				const localId = generateLocalId();
				// TODO: CCINT-7833 - replace with the id returned by the
				// agent-managed-object backend once that integration exists.
				const parameters: AgentManagedExtensionParameters = {
					aiManagedObjectId: generateAiManagedObjectId(),
				};
				return Promise.resolve({
					type: 'bodiedExtension',
					attrs: {
						extensionKey: AGENT_MANAGED_EXTENSION_KEY,
						extensionType,
						parameters,
						layout: 'default',
						localId,
					},
					content: [
						{
							type: 'paragraph',
						},
					],
				});
			},
		},
	];
};
